module.exports = __webpack_public_path__ + "static/img/imagePeFal.0c22b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/imagePeFal.png
// module id = AJO1
// module chunks = 63